<template>
  <div>
    <v-card tile elevation="0" class="item-card">
      <v-container fluid>
        <v-row justify="space-between">
          <v-col cols="6" sm="3">
            <general-button btn_type="info" btn_block @click-event="onSubmit"
              ><template v-slot:icon
                ><v-icon left>mdi-content-save</v-icon></template
              >保存</general-button
            >
          </v-col>
          <v-col cols="6" sm="3">
            <general-button
              btn_type="info"
              btn_block
              @click-event="addRoomCard"
              :btn_disabled="room_card.length >= 10"
              ><template v-slot:icon><v-icon left>mdi-plus</v-icon></template
              >ルームを追加</general-button
            >
          </v-col>
        </v-row>
      </v-container>
      <div class="pa-2">
        <h3>ルーム情報の設定</h3>
        <div class="mt-2 mb-2">
          <div>
            店舗情報ページにルーム情報を掲載したい場合、入力してください。最大10ルームまで設定可能です。
          </div>
        </div>
        <div class="mb-4 d-flex flex-wrap flex-sm-nowrap">
          <div
            v-for="(room, c_index) in room_card"
            :key="c_index"
            @click="scrollToRoom(c_index)"
            class="pa-2 mr-2 cursor-pointer text-subtitle-1 blue--text"
          >
            ルーム情報 {{ c_index + 1 }}
          </div>
          <div
            v-if="room_card.length === 0"
            class="pa-2 text-subtitle-1 red--text"
          >
            ルームを追加してください。
          </div>
        </div>
        <ValidationObserver ref="observer">
          <div v-for="(room, c_index) in room_card" :key="c_index">
            <div
              :id="'room_id' + c_index"
              class="room-title d-flex align-center mb-2"
            >
              <h3>ルーム情報 {{ c_index + 1 }}</h3>
              <v-btn
                icon
                small
                class="ml-2"
                :disabled="c_index === 0"
                @click="moveRoomUp(c_index)"
                ><v-icon>mdi-chevron-up</v-icon></v-btn
              >
              <v-btn
                icon
                small
                :disabled="c_index === room_card.length - 1"
                @click="moveRoomDown(c_index)"
                ><v-icon>mdi-chevron-down</v-icon></v-btn
              >
              <v-btn icon small @click="removeRoomCard(c_index)"
                ><v-icon>mdi-delete</v-icon></v-btn
              >
            </div>
            <v-container fluid>
              <v-row v-for="(item, index) in room" :key="index">
                <v-col cols="12">
                  <div v-if="item.type === 'text'">
                    <ValidationProvider
                      v-slot="{ errors, valid }"
                      :name="item.name"
                      rules="required|max:255"
                    >
                      <v-text-field
                        v-model="item.detail"
                        :name="item.category_code"
                        :label="item.name"
                        :error-messages="errors"
                        :success="valid"
                        outlined
                        hint="必須項目です。ルーム名を入力してください。"
                        persistent-hint
                      ></v-text-field>
                    </ValidationProvider>
                  </div>
                  <div v-if="item.type === 'textarea'">
                    <v-textarea
                      v-model="item.detail"
                      :name="item.category_code"
                      :label="item.name"
                      :success="true"
                      outlined
                      hide-details
                      rows="3"
                      auto-grow
                    ></v-textarea>
                  </div>
                  <div v-if="item.type === 'html'">
                    <div class="font-weight-bold">{{ item.name }}</div>
                    <div class="mt-2 mb-2">
                      <v-btn
                        text
                        color="primary"
                        class="font-weight-bold pa-1 d-inline"
                        @click="onHtmlClear(c_index)"
                        >HTMLをクリア</v-btn
                      >
                      <p class="mini text-red">
                        ※GoogleMapやバナー等のHTMLを使用する際は「ソース」をクリックしてから、HTMLを貼り付け、再度「ソース」をクリックして元の画面に戻ってから保存してください。
                      </p>
                    </div>
                    <v-card tile elevation="0" class="mb-6">
                      <div class="ma-3">
                        <ckeditor-component
                          :ref="item.ref"
                          :data="item.detail"
                        ></ckeditor-component>
                      </div>
                    </v-card>
                  </div>
                </v-col>
              </v-row>
            </v-container>
            <v-divider class="mt-4 mb-4"></v-divider>
          </div>
        </ValidationObserver>
      </div>
      <v-container fluid>
        <v-row justify="space-between">
          <v-col cols="6" sm="3">
            <general-button btn_type="info" btn_block @click-event="onSubmit"
              ><template v-slot:icon
                ><v-icon left>mdi-content-save</v-icon></template
              >保存</general-button
            >
          </v-col>
          <v-col cols="6" sm="3">
            <general-button
              btn_type="info"
              btn_block
              @click-event="addRoomCard"
              :btn_disabled="room_card.length >= 10"
              ><template v-slot:icon><v-icon left>mdi-plus</v-icon></template
              >ルームを追加</general-button
            >
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import {
  ref,
  set,
  reactive,
  toRefs,
  defineComponent,
  watch,
  onMounted,
} from "@vue/composition-api";
import store from "@/store/index.js";
import { repositoryFactory } from "@/repository/repositoryFactory";
import setting from "@/common/setting.js";
import imageUploaderComponent from "./imageUploader.vue";
import retryRequest from "@/common/retryRequest";

export default defineComponent({
  components: {
    imageUploaderComponent,
  },
  props: ["shop_site_id"],
  setup(props, ctx) {
    const HpListDetailRepository = repositoryFactory.get("hpListDetails");

    const data_id = 4; // ルーム設定 4固定
    const state = reactive({
      // 入力項目カテゴリごとのデータ構造体
      room_card: [],
    });
    const category_items = {
      room_name: {
        type: "text",
        ref: "refRoomName",
        category_num: 0,
        category_code: "room_name",
        name: "ルーム名",
        detail: "",
        sort: 1,
      },
      room_info: {
        type: "textarea",
        ref: "refRoomName",
        category_num: 0,
        category_code: "room_info",
        name: "ルームに関する情報",
        detail: "",
        sort: 2,
      },
      room_info_html: {
        type: "html",
        ref: "refRoomInfoHtml",
        category_num: 0,
        category_code: "room_info_html",
        name: "ルームに関する情報 HTML",
        detail: "",
        sort: 3,
      },
    };

    const getListData = async () => {
      // サイト設定データ取得
      store.dispatch("loadingIcon/showIcon"); // ローディング表示

      const params = {
        shop_site_id: props.shop_site_id,
        data_id: data_id,
      };
      const response = await retryRequest(
        HpListDetailRepository.list_data,
        params,
        true
      );
      if (response.data) {
        if (response.data.length === 0) {
          // データがない場合は何もしない
        } else {
          // 取得したデータをstateにセット
          for (const getItem of response.data) {
            const itemData = {
              ...category_items[getItem.category_code],
              category_num: getItem.category_num,
              name: getItem.name,
              detail: getItem.detail,
              sort: getItem.sort,
            };
            const cardIndex = getItem.category_num - 1;
            if (state.room_card.length <= cardIndex) {
              // ルームカードが足りない場合は追加
              for (let i = state.room_card.length; i <= cardIndex; i++) {
                state.room_card.push({});
              }
            }
            if (state.room_card[cardIndex]) {
              set(state.room_card[cardIndex], getItem.category_code, itemData);
            }
          }
        }
      }

      // ローディング非表示
      store.dispatch("loadingIcon/hideIcon");
    };

    onMounted(() => {
      getListData();
    });

    const onSubmit = async () => {
      // 入力チェック エラー状態の部品が無いか調べる
      const isValid = await ctx.refs.observer.validate();

      if (!isValid) {
        // エラー処理
        const el = document.querySelectorAll(
          ".v-text-field.error--text, .v-textarea.error--text"
        );
        if (el.length > 0) {
          el[0].scrollIntoView();
          window.scrollBy(0, -80);
        }
        return;
      } else {
        // サイト設定保存処理
        if (!window.confirm("保存してよろしいですか？")) {
          return false;
        }

        store.dispatch("loadingIcon/showIcon"); // ローディング表示

        const save_list = [];
        let index = 0;
        for (const card of state.room_card) {
          for (const key in card) {
            if (card[key].type === "html") {
              // HTMLの場合はCKEditorの内容を取得
              card[key].detail = ctx.refs[card[key].ref][index].editorData;
            }
            save_list.push({
              shop_site_id: props.shop_site_id,
              data_id: data_id,
              category_num: index + 1,
              category_code: card[key].category_code,
              name: card[key].name,
              detail: card[key].detail,
              sort: card[key].sort,
            });
          }
          index++;
        }
        const params = {
          shop_site_id: props.shop_site_id,
          data_id: data_id,
          save_list: save_list,
        };
        await HpListDetailRepository.save_list(params)
          .then((response) => {
            if (response.data) {
              // 保存OK
              alert("ルーム情報を保存しました。");
            }
          })
          .catch((error) => {
            throw "ERROR:HpListDetailRepository.save_list (" + error + ")";
          });

        // ローディング非表示
        store.dispatch("loadingIcon/hideIcon");
        ctx.refs.observer.reset();
      }
    };

    const onHtmlClear = (card_index) => {
      if (
        !window.confirm("HTMLに入力された内容をクリアします。よろしいですか？")
      ) {
        return;
      }
      state.room_card[card_index].room_info_html.detail = ""; // HTML内容をクリア
      ctx.refs[state.room_card[card_index].room_info_html.ref][
        card_index
      ].editorData = ""; // CKEditorの内容もクリア
    };

    const scrollToRoom = (c_index) => {
      const el = document.getElementById("room_id" + c_index);
      if (el) el.scrollIntoView({ behavior: "auto" });
    };

    // ルーム情報の上下入れ替え
    const moveRoomUp = (index) => {
      if (index > 0) {
        const tmp = state.room_card[index - 1];
        set(state.room_card, index - 1, state.room_card[index]);
        set(state.room_card, index, tmp);
        scrollToRoom(index - 1); // 上に移動した場合はスクロール
      }
    };
    const moveRoomDown = (index) => {
      if (index < state.room_card.length - 1) {
        const tmp = state.room_card[index + 1];
        set(state.room_card, index + 1, state.room_card[index]);
        set(state.room_card, index, tmp);
        scrollToRoom(index + 1); // 下に移動した場合はスクロール
      }
    };

    // ルーム情報追加
    const addRoomCard = () => {
      const newCard = {
        room_name: {
          ...category_items.room_name,
        },
        room_info: {
          ...category_items.room_info,
        },
        room_info_html: {
          ...category_items.room_info_html,
        },
      };
      state.room_card.push(newCard);
    };

    // ルーム情報削除
    const removeRoomCard = (index) => {
      if (!window.confirm("ルーム情報を削除します。よろしいですか？")) {
        return;
      }
      state.room_card.splice(index, 1);
    };

    // 返却オブジェクト定義
    return {
      setting,
      ...toRefs(state),
      onSubmit,
      onHtmlClear,
      scrollToRoom,
      moveRoomUp,
      moveRoomDown,
      removeRoomCard,
      addRoomCard,
    };
  },
});
</script>

<style scoped>
.room-title {
  margin-top: -30px;
  padding-top: 50px;
  margin-bottom: 10px;
  font-weight: bold;
}
</style>
